import type { BoardSummary } from "../api/client";

export type RecentBoardGroup = {
  label: string;
  boards: BoardSummary[];
};

function startOfDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function daysAgo(n: number): Date {
  const d = startOfDay(new Date());
  d.setDate(d.getDate() - n);
  return d;
}

export function groupBoardsByRecency(boards: BoardSummary[]): RecentBoardGroup[] {
  const sorted = [...boards].sort(
    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  const today = startOfDay(new Date());
  const yesterday = daysAgo(1);
  const weekAgo = daysAgo(7);
  const monthAgo = daysAgo(30);

  const buckets: Record<string, BoardSummary[]> = {
    Сегодня: [],
    Вчера: [],
    "На этой неделе": [],
    "В этом месяце": [],
    Ранее: [],
  };

  for (const b of sorted) {
    const t = new Date(b.updated_at);
    if (t >= today) buckets["Сегодня"]!.push(b);
    else if (t >= yesterday) buckets["Вчера"]!.push(b);
    else if (t >= weekAgo) buckets["На этой неделе"]!.push(b);
    else if (t >= monthAgo) buckets["В этом месяце"]!.push(b);
    else buckets["Ранее"]!.push(b);
  }

  return Object.entries(buckets)
    .filter(([, items]) => items.length > 0)
    .map(([label, items]) => ({ label, boards: items }));
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes <= 0) return "";
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}
